import {Router} from './Router';
import './index.css';
import 'tailwindcss/tailwind.css';
import {Header} from './components/Header/Header';
import {Footer} from './components/Footer/Footer';
import {useLocation} from 'react-router-dom';
import {LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import ja from 'date-fns/locale/ja'
import {createTheme, ThemeOptions, ThemeProvider} from "@mui/material";
import {
  createTheme as v4createTheme,
  ThemeOptions as v4ThemeOptions,
  ThemeProvider as V4ThemeProvider
} from "@material-ui/core";

const themeOptions: ThemeOptions | v4ThemeOptions = {
  palette: {
    primary: {
      main: "#541414"
    }
  }
};

const theme = createTheme(themeOptions as ThemeOptions);
const v4theme = v4createTheme(themeOptions as v4ThemeOptions);

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <V4ThemeProvider theme={v4theme}>
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ja}>
          <div className='flex flex-col min-h-screen'>
            <Header/>
            <main className={'flex flex-1 flex-col min-w-screen mb-12' + (useLocation().pathname === '/' ? '' : ' mt-8')}>
              <div className={'flex-1'}>
                <Router/>
              </div>
            </main>
            <Footer/>
          </div>
        </LocalizationProvider>
      </V4ThemeProvider>
    </ThemeProvider>
  );
};

export default App;
